import { TOKEN_KEY } from '@/config/authing'
import { hasCookie, getCookie, setCookie, deleteCookie } from 'cookies-next'
import { GetServerSidePropsContext } from 'next'

export const getTokenByClient = () => {
  if (hasCookie(TOKEN_KEY)) {
    return getCookie(TOKEN_KEY) as string
  }
  return null
}
export const getTokenByServe = (context: GetServerSidePropsContext<any>) => {
  return getCookie(TOKEN_KEY, { req: context.req, res: context.res }) as string || null
}


export const setToken = (value: string) => {
  setCookie(TOKEN_KEY, value, {
    path: '/',
    expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
    secure: true,
    sameSite: 'none'
  })
}

export const deleteToken = () => {
  deleteCookie(TOKEN_KEY, {
    path: '/'
  })
}